export const dixaWidgetScriptUrl = 'https://widget.dixa.io/assets/scripts/javascript/loader.js';
export const dixaWidgetId = '9eb1caef-56ba-43e9-9e53-bcd0d58b2550';
export const dixaWidgetAccessKey = '_dixa';
export function dixaWidgetSetUser(profile) {
    var _a;
    const { name, email } = profile;
    if (name && email) {
        (_a = window === null || window === void 0 ? void 0 : window._dixa) === null || _a === void 0 ? void 0 : _a.call(window, 'api.setUser', name, email);
    }
}
export function dixaWidgetPurgeUser() {
    var _a;
    (_a = window === null || window === void 0 ? void 0 : window._dixa) === null || _a === void 0 ? void 0 : _a.call(window, 'api.purgeUser');
}
export function dixaWidgetLoader() {
    const tagName = 'script';
    (function (window, document, url, widgetAccessKey, widgetId, newScript, firstScript) {
        var _a;
        window[widgetAccessKey] =
            window[widgetAccessKey] ||
                function () {
                    var _a, _b;
                    (window[widgetAccessKey].q = window[widgetAccessKey].q || []).push(
                    // eslint-disable-next-line prefer-rest-params
                    arguments);
                    // eslint-disable-next-line prefer-rest-params
                    (_b = (_a = window[widgetAccessKey]) === null || _a === void 0 ? void 0 : _a.handler) === null || _b === void 0 ? void 0 : _b.call(_a, arguments);
                };
        window[widgetAccessKey].l = Date.now();
        window[widgetAccessKey].wid = widgetId;
        newScript.async = true;
        newScript.setAttribute('charset', 'utf-8');
        newScript.src = url;
        newScript.onload = injectStyles;
        (_a = firstScript.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(newScript, firstScript);
    })(window, document, dixaWidgetScriptUrl, dixaWidgetAccessKey, dixaWidgetId, document.createElement(tagName), document.getElementsByTagName(tagName)[0]);
}
function injectStyles() {
    var _a, _b;
    const widgetFrame = window.frames['dixa-widget-wrapper'];
    if (!widgetFrame) {
        // there is no way to know when iframe is added to the window
        // and it's not possible to use frame.onload
        setTimeout(injectStyles, 50);
        return;
    }
    const style = document.createElement('style');
    // Hide the button inject by the script. We show a custom button instead.
    style.innerHTML = `#minimized-button { display: none; }`;
    (_b = (_a = widgetFrame.contentDocument) === null || _a === void 0 ? void 0 : _a.querySelector('head')) === null || _b === void 0 ? void 0 : _b.appendChild(style);
}
